import { useContext } from "react";

import { ItemsContextUnit } from "../Provider";

export const useItemsContext = () => {
  const itemsContext = useContext(ItemsContextUnit);

  if (itemsContext === null) {
    throw new Error("Context not provided");
  }

  return {
    ...itemsContext,
  };
};
